<template>
  <div id="shop-checkout">
    <!-- header image -->
    <v-container fluid pa-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 sm6 xs12>
          <v-img :src="require('@/assets/shop/shop_header.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- content -->
    <v-container grid-list-xl pt-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 px-0 sm8 xs12>
          <v-img :src="require('@/assets/shop/shop_header-1.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>

      <v-layout
        align-center
        justify-center
        :key="state.idx"
        row
        text-xs-center
        v-for="state in states"
        wrap
      >
        <v-flex sm4 xs7>
          <v-img contain :src="getProductItemPicture(state.shopEditionProductItemId)"></v-img>
        </v-flex>
        <v-flex pb-0 pt-2 sm9 xs12>
          <div
            class="display-1 font-weight-bold"
          >{{ getProductItemName(state.shopEditionProductItemId) }}</div>
        </v-flex>
        <v-flex pt-0 sm9 xs12>
          <span class="subheading">{{ state.name }}</span>
          <span class="subheading pl-2">{{ formatNumber(state.price, state.quantity) + ' บาท' }}</span>
        </v-flex>
        <v-flex pt-0 sm9 xs6>
          <div class="subheading">จำนวน</div>
          <div class="card-quantity mt-2">
            <div class="title">{{ state.quantity }}</div>
          </div>
        </v-flex>
        <v-flex sm9 xs12></v-flex>
      </v-layout>
      <!-- Total -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm4 text-xs-center xs12>
          <div class="display-1 font-weight-bold">ราคารวม {{ totalPrice + ' บาท' }}</div>
        </v-flex>
      </v-layout>
      <!-- bank -->
      <v-layout align-center justify-center row wrap>
        <v-flex mt-2 sm4 xs12>
          <v-card color="#F37022" elevation="0">
            <v-card-text>
              <v-layout align-center justify-center row wrap>
                <v-flex xs3>
                  <v-img
                    src="https://lh3.googleusercontent.com/b8YX-8Ty6QrG11U8_RfFurBIzniWArohRwWeUK2BgZaQx8QxmBzNzoXItzkcyBXeD4a9"
                  ></v-img>
                </v-flex>
                <v-flex xs9>
                  <v-layout align-center class="white--text" justify-center row wrap>
                    <v-flex xs12>
                      <div>
                        <span class="subheading">ธนาคาร</span>
                        <span class="subheading font-weight-bold ml-4">ธนชาต</span>
                      </div>
                      <div>
                        <span class="subheading">ประเภท</span>
                        <span class="subheading font-weight-bold ml-4">เงินฝากออมทรัพย์</span>
                      </div>
                      <div>
                        <span class="subheading">ชื่อบัญชี</span>
                        <span class="subheading font-weight-bold ml-4">อานนท์ บุณยประเวศ</span>
                      </div>
                      <div>
                        <span class="subheading">เลขที่บัญชี</span>
                        <span class="subheading font-weight-bold ml-4">0986078503</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- form -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm4 text-xs-center xs12>
          <v-text-field
            clearable
            data-vv-name="name"
            :error-messages="errors.collect('name')"
            label="ชื่อ"
            v-model="formData.firstname"
            v-validate="'required'"
          ></v-text-field>
          <v-text-field
            clearable
            data-vv-name="lastname"
            :error-messages="errors.collect('lastname')"
            label="นามสกุล"
            v-model="formData.lastname"
            v-validate="'required'"
          ></v-text-field>
          <v-text-field
            clearable
            data-vv-name="phone"
            :error-messages="errors.collect('phone')"
            label="เบอร์โทรติดต่อ"
            mask="###-###-####"
            v-model="formData.phone"
            v-validate="'required|min:10'"
          ></v-text-field>
          <v-textarea
            clearable
            data-vv-name="address"
            :error-messages="errors.collect('address')"
            label="ที่อยู่จัดส่ง"
            v-model="formData.address"
            v-validate="'required'"
          ></v-textarea>
          <v-autocomplete
            clearable
            data-vv-name="province"
            :error-messages="errors.collect('province')"
            @input="checkProvince"
            :items="provinces"
            item-text="nametha"
            item-value="id"
            label="จังหวัด"
            v-model="formData.province"
            v-validate="'required'"
          ></v-autocomplete>
          <!-- district -->
          <v-autocomplete
            clearable
            data-vv-name="districts"
            :disabled="formData.province ? false : true"
            :error-messages="errors.collect('districts')"
            @input="checkDistrict"
            :items="districts"
            item-text="nametha"
            item-value="id"
            label="อำเภอ"
            v-model="formData.district"
            v-validate="'required'"
          ></v-autocomplete>
          <!-- sub district -->
          <v-autocomplete
            clearable
            data-vv-name="subdistrit"
            :disabled="formData.district ? false : true"
            :error-messages="errors.collect('subdistrit')"
            :items="subDistricts"
            item-text="nametha"
            item-value="id"
            label="ตำบล"
            v-model="formData.subDistrict"
            v-validate="'required'"
          ></v-autocomplete>
          <!-- zipcode -->
          <v-text-field
            clearable
            data-vv-name="zipcode"
            :error-messages="errors.collect('zipcode')"
            label="รหัสไปรษณีย์"
            type="number"
            v-model.number="formData.zipcode"
            v-validate="'required'"
          ></v-text-field>
          <v-btn
            block
            @click="onPickFile"
            color="yellow darken-2"
            dark
            depressed
            large
            style="border-radius:8px"
            v-if="!fileSlip"
          >อัพโหลดใบโอนเงิน</v-btn>
          <div v-else>
            <span class="body-2 primary--text pr-2">แนบใบโอนเงินเรียบร้อย</span>
            <span class="body-2 red--text" @click="clearFileInput">ยกเลิก</span>
          </div>
          <v-btn
            block
            class="mt-4"
            @click="doSubmit"
            color="primary"
            dark
            depressed
            :disabled="fileSlip ? false : true"
            large
            :loading="dialogLoading"
            style="border-radius:8px"
          >สั่งซื้อ</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <input
      accept="image/*"
      @change="detectFiles($event)"
      id="files"
      :multiple="false"
      name="file"
      ref="uploadInput"
      style="display:none"
      type="file"
    />
  </div>
</template>

<script>
import firebase from 'firebase/app' // Storage
import 'firebase/storage'

export default {
  name: 'shop-checkout',
  data() {
    return {
      formData: [],
      fileSlip: null,
      downloadURL: null,
      dialogLoading: false
    }
  },
  computed: {
    provinces() {
      return this.$store.getters['Place/getProvinceAll']
    },
    districts() {
      return this.$store.getters['Place/getDistrictAll'].filter(
        item => item.provinceid == this.formData.province
      )
    },
    subDistricts() {
      return this.$store.getters['Place/getSubDistrictAll'].filter(
        item => item.districtid == this.formData.district
      )
    },
    states() {
      return this.$store.getters['Cart/getAll']
    },
    totalPrice() {
      let total = this.states.reduce(
        (previousValue, currentValue) => previousValue + currentValue.price * currentValue.quantity,
        0
      )
      return this.formatNumber(total, 1)
    }
  },
  mounted() {
    if (this.states.length === 0) this.$router.push({ name: 'home' })
  },
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const downloadURL = await this.upload(this.fileSlip) // Call function uploadFirebase
          this.states.forEach(async state => {
            let data = {
              shopEditionProductItemPriceId: state.idx,
              quantity: state.quantity,
              totalPrice: state.price * state.quantity,
              ...this.formData,
              status: 'รอตรวจสอบ',
              transferSlip: downloadURL
            }
            const idx = await this.$store.dispatch(`ShopOrderList/insert`, data)
            this.$store.commit('Cart/CLEAR_CART') // clear cart
            if (idx) this.$router.push({ name: 'shop-confirm' })
          })
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    clearFileInput() {
      this.fileSlip = null
      const input = this.$refs.uploadInput
      input.type = 'text'
      input.type = 'file'
    },
    async upload(file) {
      try {
        // Upload images to firebase and get URL
        var storageRef = firebase.storage().ref()

        var ext = file.name.slice(file.name.lastIndexOf('.'))

        // Create the file metadata
        var metadata = {
          contentType: 'image/jpeg'
        }

        // Create Timestamp
        let timestamp = Date.now()

        // Upload file and metadata to the object 'images/mountains.jpg'
        var uploadTaskSnapshot = await storageRef
          .child(`transfer_slip/${timestamp}${ext}`)
          .put(file, metadata)

        const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL()
        // reset file input
        const input = this.$refs.uploadInput
        input.type = 'text'
        input.type = 'file'
        return downloadURL
      } catch (error) {
        throw new Error(error)
      }
    },
    onPickFile() {
      this.$refs.uploadInput.click()
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.fileSlip = fileList[x]
      })
    },
    checkRegion(region) {
      if (!region) {
        this.formData.provinceId = null
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkProvince(province) {
      if (!province) {
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkDistrict(district) {
      if (!district) {
        this.formData.subDistrictId = null
      }
    },
    formatNumber(num, quantity) {
      let price = num * quantity
      return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    getProductItemName(shopEditionProductId) {
      return this.$store.getters['ShopEditionProductItem/getAll']
        .filter(item => item.idx == shopEditionProductId)
        .map(item => item.name)
        .toString()
    },
    getProductItemPicture(shopEditionProductId) {
      let picture = this.$store.getters['ShopEditionProductItem/getAll']
        .filter(item => item.idx == shopEditionProductId)
        .map(item => item.picture)
        .toString()

      return picture ? picture : require('@/assets/NoPicture.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-quantity {
  border: 1px solid grey;
  padding: 20px;
}
</style>
